export const environment = {
  production: true,
  enableLogging: false,
  backendEndpoint: 'https://backend.chaseyoursport.com/api',
  analtixHubEndpoint: 'https://analytixhub.chaseyoursport.com/api'
};
